export const TEST_ID_MOBILE_SUMMARY_TOURIST_INFO =
  'mobile-summary-tourist-info';
